import Loadable from "react-loadable";

export const PostMoreMenu = Loadable({
  loader: () => import("../../../../modules/manage-posts").then((module) => module.PostMoreMenu) as Promise<any>,
  loading: () => null,
});
